export { default as mockItem, type IItemExample } from "./mockItem";
